export default __webpack_public_path__ + "static/media/badge-oldwinner.7ee0d60b.png";